module.exports = __webpack_public_path__ + "img/docs-uploaded.77dc60f7.svg";